import { Dialog, DialogPanel } from "@headlessui/react";
import { IoMdClose, IoMdSearch } from "react-icons/io";
import { useState, useEffect } from "react";
import { FiPlus } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { ApiGet, ApiPost } from "../../helper/axiosFunctions";
import { useLocation } from "react-router-dom";
import { commonToast } from "../../helper/Toast";
import { ImSpinner8 } from "react-icons/im";
import { useSelector } from "react-redux";
import { getSelectedSchoolId } from "../../helper/commonFunctions";

export default function AddPeopleModel({ isaddpeople, setisAddPeople, fetchdata, peopleList }) {
  const { t } = useTranslation();
  const [tab, setTab] = useState(t("search"));
  // const [selectedItems, setSelectedItems] = useState({});
  // const [selectedClass, setSelectedClass] = useState({});
  const [teachers, setTeachers] = useState([]);
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [addingUserIds, setAddingUserIds] = useState(new Set());
  const classDataRedux = useSelector((state) => state.classData.data);

  const { pathname } = useLocation();
  const classId = pathname.split('/')[2];

  //comment for now
  // useEffect(() => {
  //   if (classId) {
  //     if (tab === t("class")) {
  //       fetchTeachers();
  //     } else if (tab === t("search")) {
  //       fetchStudents();
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [tab, classId]);

  const fetchTeachers = async () => {
    setLoading(true);
    try {
      const response = await ApiGet(`/contents/classes/${classId}/teachers`);
      setTeachers(response?.data || []);
    } catch (error) {
      commonToast(error?.data?.errorDescription || error?.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchStudents = async (query = "") => {
    setLoading(true);
    try {
      const response = await ApiGet(`/contents/schools/${getSelectedSchoolId()}/students`);
      if (response.data && response.data.students) {
        setStudents(response.data.students);
      }
    } catch (error) {
      commonToast(error?.data?.errorDescription || error?.data?.error || error?.message, "error");
    } finally {
      setLoading(false);
    }
  };


  const handleAddUser = async (user) => {
    setAddingUserIds(prev => new Set([...prev, user.userId]));
    try {
      if (user.userRoles?.includes('zubrus_student')) {
        await ApiPost(`/contents/classes/${classId}/students/${user.userId}`)
          .then(async () => {
            const isStudentsAvailable = await peopleList?.some((item) => item.role === "student")

            if (!isStudentsAvailable) {

              await ApiGet(`/activities/classes/${classId}`)
                .then(async (res1) => {

                  if (!res1?.data?.length) {

                    await ApiPost('/activities', {
                      name: classDataRedux?.className,
                      description: classDataRedux?.className,
                      decks: [],
                      activityType: "TEST"
                    })
                      .then(async (res2) => {

                        if (res2?.data) {
                          await ApiPost('/activities/assignment', { activityId: res2?.data?._id, classes: [classId] })
                            .then(() => {
                              console.log('Activity assigned to ' + classId)
                            })
                            .catch((error3) => {
                              commonToast(error3?.data?.errorDescription || error3?.message, "error");
                            })
                        }

                      })
                      .catch((error2) => {
                        commonToast(error2?.data?.errorDescription || error2?.message, "error");
                      })

                  }
                })
                .catch((error1) => {
                  commonToast(error1?.data?.errorDescription || error1?.message, "error");
                })
            }
          })
          .catch((error) => {
            commonToast(error?.data?.errorDescription || error?.message, "error");
          })
        commonToast(t("student_added_successfully"), "success");
      } else if (user.userRoles?.includes('zubrus_teacher')) {
        await ApiPost(`/contents/classes/${classId}/teachers/${user.userId}`);
        commonToast(t("teacher_added_successfully"), "success");
      }
      // Refresh the list after adding
      // if (tab === t("class")) {
      //   fetchTeachers();
      // } else {
      //   fetchStudents();
      // }
    } catch (error) {
      commonToast(error?.data?.errorDescription || error?.message, "error");
    } finally {
      // setLoading(false);
      fetchdata()
      setAddingUserIds(prev => {
        const newSet = new Set(prev);
        newSet.delete(user.userId);
        return newSet;
      });
    }
  };
  // const handleRemoveUser = async (user) => {
  //   setLoading(true);
  //   try {
  //     if (user.userRoles?.includes('zubrus_student')) {
  //       await ApiDelete(`/contents/classes/${classId}/students/${user.userId}`);
  //       commonToast(t("student_removed_successfully"), "success");
  //     } else if (user.userRoles?.includes('zubrus_teacher')) {
  //       await ApiDelete(`/contents/classes/${classId}/teachers/${user.userId}`);
  //       commonToast(t("teacher_removed_successfully"), "success");
  //     }
  //     // Refresh the list after removing
  //     if (tab === t("class")) {
  //       fetchTeachers();
  //     } else {
  //       fetchStudents();
  //     }
  //   } catch (error) {
  //     commonToast(error?.data?.errorDescription || error?.message, "error");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const toggleSelection = (user) => {
  //   if (selectedItems[user.id]) {
  //     handleRemoveUser(user);
  //   } else {
  //     handleAddUser(user);
  //   }
  //   setSelectedItems((prev) => ({
  //     ...prev,
  //     [user.id]: !prev[user.id],
  //   }));
  // };

  // const toggleSelectionClass = (user) => {
  //   if (selectedClass[user.id]) {
  //     handleRemoveUser(user);
  //   } else {
  //     handleAddUser(user);
  //   }
  //   setSelectedClass((prev) => ({
  //     ...prev,
  //     [user.id]: !prev[user.id],
  //   }));
  // };

  const getRoleChip = (roles) => {
    if (roles?.includes('zubrus_student')) {
      return (
        <span className="text-xs w-fit bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
          {t("student")}
        </span>
      );
    }
    else if (roles?.includes('zubrus_teacher')) {
      return (
        <span className="text-xs w-fit bg-green-100 text-green-800 px-2 py-1 rounded-full">
          {t("teacher")}
        </span>
      );
    }
    else if (roles?.includes('zubrus_content_creator')) {
      return (
        <span className="text-xs w-fit bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full">
          {t("content-creator")}
        </span>
      );
    }
    return null;
  };
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (tab === t("search") && classId) {
        fetchStudents(searchQuery);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery, tab, classId]);

  return (
    <div>
      <Dialog
        open={isaddpeople}
        as="div"
        className="relative z-30 focus:outline-none"
        onClose={() => {
          setisAddPeople(true);
        }}
      >
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 bg-black/35 backdrop-blur-sm ">
            <DialogPanel
              transition
              className="w-full relative max-w-md rounded-3xl bg-white duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0"
            >
              <div className="p-6  bg-white relative z-10  rounded-3xl">
                <div className="flex justify-between items-center text-xl font-semibold">
                  <h2>
                    {t("add")} {t("people")}
                  </h2>
                  <IoMdClose
                    className="absolute right-5 top-5 cursor-pointer"
                    fontSize={20}
                    onClick={() => {
                      setisAddPeople(false);
                    }}
                  />
                </div>
                <div className="h-14 border-b flex flex-wrap justify-between items-center text-xl font-semibold">
                  <ul className="flex flex-wrap items-center gap-5 text-base h-full text-lightgray font-semibold">
                    {/* {[t("search"), t("class")]?.map((item, index) => ( */}
                    {[t("search")]?.map((item, index) => (
                      <li
                        key={index}
                        onClick={() => setTab(item)}
                        className={`${item === t(tab) && "border-b border-black text-black "
                          } h-full  flex items-center justify-center cursor-pointer`}
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="flex items-center">
                  <IoMdSearch
                    className="absolute ms-2 text-lightgray"
                    fontSize={24}
                  />

                  <input
                    type="text"
                    placeholder={`${t("name")} , ${t("lastname")}`}
                    className=" regular-text border h-[56px] my-5 w-full rounded-xl ps-10 shadow-inner outline-none placeholder:text-lightgray text-black"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>

                <div className="space-y-3 h-72 overflow-y-auto overflow-x-hidden">
                  {tab === t("search") ? (
                    <>
                      <div className="mb-5">
                        <div className="flex text-sm capitalize items-center gap-3 border rounded-xl w-fit px-2 py-2">
                          {[t("activity"), t("Performance")]?.map((item) => (
                            <div
                              key={item}
                              className={`cursor-pointer ${item === t("activity") &&
                                "bg-darkblue text-white rounded-lg px-2 py-1"
                                } px-3`}
                            >
                              {item}
                            </div>
                          ))}
                        </div>
                      </div>
                      {loading ? (
                        <div className="text-center py-4">Loading...</div>
                      ) : students.length > 0 ? (
                        students.map((student, key) => (
                          <div
                            key={key}
                            className="flex justify-between items-center"
                          >
                            <div className="flex items-center gap-3">
                              <img
                                src={student?.profileImage || "/assets/images/Avatar.png"}
                                alt={student?.name}
                                className="size-10 rounded-full"
                              />
                              <div className="flex flex-col">
                                <span className="regular-text">
                                  {student?.firstName || "-"} {student?.lastName}
                                </span>
                                {getRoleChip(student?.userRoles)}
                              </div>
                            </div>
                            <div>
                              {addingUserIds.has(student.userId) ? (
                                <ImSpinner8 className="text-blue-500 text-xl animate-spin border rounded-full size-8 p-1 flex justify-center items-center" />
                              ) : (
                                <FiPlus
                                  onClick={() => handleAddUser(student)}
                                  fontSize={20}
                                  className="border cursor-pointer rounded-full size-8 p-1 flex justify-center items-center hover:bg-blue-50 transition-colors duration-200"
                                />
                              )}
                            </div>
                            {/* <div>
                              {selectedItems[student.id] ? (
                                <img
                                  onClick={() => toggleSelection(student)}
                                  src="/assets/images/Circle.png"
                                  alt={student.name}
                                  className="size-8 rounded-full cursor-pointer"
                                />
                              ) : (
                                <FiPlus
                                  onClick={() => toggleSelection(student)}
                                  fontSize={20}
                                  className="border cursor-pointer rounded-full size-8 p-1 flex justify-center items-center"
                                />
                              )}
                            </div> */}
                          </div>
                        ))
                      ) : (
                        <div className="text-center py-4 text-gray-500">
                          No students found
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      {loading ? (
                        <div className="text-center py-4">Loading...</div>
                      ) : teachers.length > 0 ? (
                        teachers.map((teacher, key) => (
                          <div
                            key={key}
                            className="flex justify-between items-center"
                          >
                            <div className="flex items-center gap-3">
                              <img
                                src={teacher?.profileImage || "/assets/images/Avatar.png"}
                                alt={teacher?.name}
                                className="size-10 rounded-full"
                              />
                              <div className="flex flex-col">
                                <span className="regular-text">{teacher?.name}</span>
                                {getRoleChip(teacher?.userRoles)}
                              </div>
                            </div>
                            {/* <div>
                              {selectedClass[teacher.id] ? (
                                <img
                                  onClick={() => toggleSelectionClass(teacher)}
                                  src="/assets/images/Circle.png"
                                  alt={teacher.name}
                                  className="size-8 rounded-full cursor-pointer"
                                />
                              ) : (
                                <FiPlus
                                  onClick={() => toggleSelectionClass(teacher)}
                                  fontSize={20}
                                  className="border cursor-pointer rounded-full size-8 p-1 flex justify-center items-center"
                                />
                              )}
                            </div> */}
                            <div>
                              {addingUserIds.has(teacher.userId) ? (
                                <ImSpinner8 className="text-blue-500 text-xl animate-spin border rounded-full size-8 p-1 flex justify-center items-center" />
                              ) : (
                                <FiPlus
                                  onClick={() => handleAddUser(teacher)}
                                  fontSize={20}
                                  className="border cursor-pointer rounded-full size-8 p-1 flex justify-center items-center hover:bg-blue-50 transition-colors duration-200"
                                />
                              )}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center py-4 text-gray-500">
                          No teachers found
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
